export const getQueryByUrl = (param: string, search: string) => {
  const val = new URLSearchParams(search).get(param);

  return decodeURIComponent(val || '');
};

export const getQueryArrayByUrl = (param: string, search: string): string[] => {
  return new URLSearchParams(search).getAll(param).map(decodeURIComponent);
};
